import React, { useState } from "react";
import Select from "../../UI/Form/Select/Select";
import { useSelector } from "react-redux";
import styled from "@emotion/styled";
import { useHistory } from "react-router";
import PageDisplayName from "../../UI/PageDisplayName";
import Flex from "../../UI/Flex/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import { Link } from "react-router-dom";
import useUserAccess from "../../hooks/useUserAccess";
import { highlightWithMark } from "../../utils/jsx";
import { sortBy } from "lodash-es";
import { getPages } from "../../store/actions";

export default function GlobalSearch({ dispatch }) {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const userAccess = useUserAccess();
  const history = useHistory();

  const tabs = useSelector((state) => state.layout.tabs);
  const blocks = tabs
    .map((v) => v.blocks?.map((block) => ({ ...block, page: v })))
    .flat()
    .filter(Boolean);

  const searchWordBoundaryStartRegex = new RegExp(
    `^${RegExp.escape(search)}\\b`,
    "i"
  );
  const searchStartRegex = new RegExp(`^${RegExp.escape(search)}`, "i");
  const searchWordBoundaryRegex = new RegExp(
    `\\b${RegExp.escape(search)}\\b`,
    "i"
  );

  const sortPriorityCallback = (v) =>
    searchWordBoundaryStartRegex.test(v.search)
      ? 0
      : searchWordBoundaryRegex.test(v.search)
      ? 1
      : searchStartRegex.test(v.search)
      ? 2
      : 3;

  const results = [
    {
      label: "Block results",
      options: sortBy(
        blocks
          .filter((v) => v.title)
          .map((v) => ({
            label: v.title,
            uuid: v.uuid,
            displayLabel: search ? highlightWithMark(v.title, search) : v.title,
            search: v.title,
            value: "lol",
            to: `/dashboard/${v.page.slug}`,
            page: v.page,
          }))
          .filter((v) =>
            v.search?.toLowerCase().includes(search.toLowerCase())
          ),
        sortPriorityCallback
      ).slice(0, 8),
    },
    {
      label: "Page results",
      options: sortBy(
        tabs
          .map((v) => ({
            label: v.displayName,
            uuid: v.uuid,
            displayLabel: (
              <PageDisplayName
                page={v}
                displayName={
                  search ? highlightWithMark(v.displayName, search) : undefined
                }
              />
            ),
            search: v.displayName,
            to: `/dashboard/${v.slug}`,
            value: "lol",
          }))
          .filter((v) =>
            v.search?.toLowerCase().includes(search.toLowerCase())
          ),
        sortPriorityCallback
      ).slice(0, 8),
    },
  ];

  const stopLinkPropagation = (evt) => {
    evt.stopPropagation();
    setOpen(false);
  };

  const formatOptionLabel = (v) => {
    const isBlock = v.page;

    return (
      <Flex alignItems="center" gap="1rem">
        <Link to={v.to} onClick={stopLinkPropagation} style={{ flex: 1 }}>
          <div>{v.displayLabel ?? v.label}</div>
          {isBlock ? (
            <div>
              <em>
                (<PageDisplayName page={v.page} />)
              </em>
            </div>
          ) : null}
        </Link>
        {isBlock && userAccess.pageManagement ? (
          <Link
            to={`/admin/page-management/${v.page.uuid}/blocks/${v.uuid}`}
            onClick={stopLinkPropagation}
          >
            <FontAwesomeIcon icon={faPencil} title="Edit Block" />
          </Link>
        ) : userAccess.pageManagement ? (
          <Link
            to={`/admin/page-management/${v.uuid}`}
            onClick={stopLinkPropagation}
          >
            <FontAwesomeIcon icon={faPencil} title="Edit Page" />
          </Link>
        ) : null}
      </Flex>
    );
  };

  const handleMenuOpen = () => {
    // load pages only when user want to use global search
    if (!blocks.length) {
      dispatch(getPages());
    }
    setOpen(true);
  };

  return (
    <Container>
      <Select
        containerWidth="20rem"
        placeholder="Search"
        options={results}
        inputValue={search}
        onInputChange={(value, { action }) => {
          if (action === "input-change") {
            setSearch(value); // update state when typing
          }
        }}
        formatOptionLabel={formatOptionLabel}
        onChange={(v) => {
          history.push(v.to);
        }}
        menuHeight={"100rem"}
        menuIsOpen={open}
        onMenuOpen={handleMenuOpen}
        onMenuClose={() => setOpen(false)}
      />
    </Container>
  );
}

const Container = styled.div``;
